module.exports = function(data) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div class="modal-dialog">\n    <div class="modal-content">\n        ';
 if (data.dismissable && data.title) { ;
__p += '\n        <div class="modal-header">\n            ';
 if (data.dismissable) { ;
__p += '\n            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>\n            ';
 } ;
__p += '\n            ';
 if (data.title) { ;
__p += '\n            <h4 class="modal-title">' +
((__t = ( data.title )) == null ? '' : __t) +
'</h4>\n            ';
 } ;
__p += '\n        </div>\n        ';
 } ;
__p += '\n        <div class="modal-body">\n            ' +
((__t = ( data.content )) == null ? '' : __t) +
'\n        </div>\n        ';
 if (data.buttons.length) { ;
__p += '\n        <div class="modal-footer">\n            ';
 data.buttons.forEach(function(button) { ;
__p += '\n            <button type="button" data-cid="' +
((__t = ( button.cid )) == null ? '' : __t) +
'" class="btn btn-' +
((__t = ( button.role )) == null ? '' : __t) +
' ' +
((__t = (button.className)) == null ? '' : __t) +
'" ' +
((__t = ( button.dismiss ? "data-dismiss='modal'" : "" )) == null ? '' : __t) +
'>\n                ' +
((__t = ( button.caption )) == null ? '' : __t) +
'\n            </button>\n            ';
 }); ;
__p += '\n        </div>\n        ';
 } ;
__p += '\n        ';
 if (data.footnote) { ;
__p += '\n        <div class="modal-footnote">\n            <sup>*</sup> ' +
__e( data.footnote ) +
'\n        </div>\n        ';
 } ;
__p += '\n    </div>\n</div>\n';
return __p
}